import { Root } from './Root'
import { Table } from './Table'
import { List } from './List'

export const NewItems = {
  Root,
  Table,
  List
}
